import * as Constants from './constants'

export const nhapkhoListNhaCCRequest = function nhapkhoListNhaCCRequest (formData) {  
  return {
    type: Constants.NHAPKHO_LIST_NCC_REQUESTING,
    formData
  }
}
export const nhapkhoListNhaCCSuccess = function nhapkhoListNhaCCSuccess (data) {  
  return {
    type: Constants.NHAPKHO_LIST_NCC_SUCCESS,
    data
  }
}

export const nhapkhoListNhaCCError = function nhapkhoListNhaCCError (error) {  
  return {
    type: Constants.NHAPKHO_LIST_NCC_ERROR,
    error
  }
}

export const nhapkhoListKhoRequest = function nhapkhoListKhoRequest (formData) {  
  return {
    type: Constants.NHAPKHO_LIST_KHO_REQUESTING,
    formData
  }
}
export const nhapkhoListKhoSuccess = function nhapkhoListKhoSuccess (data) {  
  return {
    type: Constants.NHAPKHO_LIST_KHO_SUCCESS,
    data
  }
}

export const nhapkhoListKhoError = function nhapkhoListKhoError (error) {  
  return {
    type: Constants.NHAPKHO_LIST_KHO_ERROR,
    error
  }
}

export const nhapkhoListProductRequest = function nhapkhoListProductRequest (formData,callback) {  
  return {
    type: Constants.NHAPKHO_LIST_PRODUCT_REQUESTING,
    formData,
    callback,
  }
}

export const nhapkhoListProductSuccess = function nhapkhoListProductSuccess (data) {  
  return {
    type: Constants.NHAPKHO_LIST_PRODUCT_SUCCESS,
    data
  }
}

export const nhapkhoListProductError = function nhapkhoListProductError (error) {  
  return {
    type: Constants.NHAPKHO_LIST_PRODUCT_ERROR,
    error
  }
}

export const nhapkhoSaveRequest = (formData, callback) => {  
  return {
    type: Constants.NHAPKHO_SAVE_REQUESTING,
    formData, 
    callback
  }
}

export const nhapkhoSaveSuccess = function nhapkhoSaveSuccess (data) {  
  return {
    type: Constants.NHAPKHO_SAVE_SUCCESS,
    data
  }
}

export const nhapkhoSaveError = function nhapkhoSaveError (error) {  
  return {
    type: Constants.NHAPKHO_SAVE_ERROR,
    error
  }
}
export const nhapkhoDetailRequest = function nhapkhoDetailRequest (formData) {  
  return {
    type: Constants.NHAPKHO_DETAIL_REQUESTING,
    formData
  }
}
  
export const nhapkhoDetailSuccess = function nhapkhoDetailSuccess (data) {  
  return {
    type: Constants.NHAPKHO_DETAIL_SUCCESS,
    data
  }
}
  
export const nhapkhoDetailError = function nhapkhoDetailError (error) {  
  return {
    type: Constants.NHAPKHO_DETAIL_ERROR,
    error
  }
}
export const nhapkhoUpdateRequest = function nhapkhoUpdateRequest (formData, callback) {  
  return {
    type: Constants.NHAPKHO_UPDATE_REQUESTING,
    formData, 
    callback
  }
}
  
export const nhapkhoUpdateSuccess = function nhapkhoUpdateSuccess (data) {  
  return {
    type: Constants.NHAPKHO_UPDATE_SUCCESS,
    data
  }
}

export const nhapkhoUpdateError = function nhapkhoUpdateError (error) {  
  return {
    type: Constants.NHAPKHO_UPDATE_ERROR,
    error
  }
}


export const nhapkhoProductsListDvtRequest = function nhapkhoProductsListDvtRequest (formData) {  
  return {
    type: Constants.NHAPKHO_PRODUCTS_LIST_DVT_REQUESTING,
    formData
  }
}

export const nhapkhoProductsListDvtSuccess = function nhapkhoProductsListDvtSuccess (data) {  
  return {
    type: Constants.NHAPKHO_PRODUCTS_LIST_DVT_SUCCESS,
    data
  }
}

export const nhapkhoProductsListDvtError = function nhapkhoProductsListDvtError (error) {  
  return {
    type: Constants.NHAPKHO_PRODUCTS_LIST_DVT_ERROR,
    error
  }
}

export const nhapkhoDuyetRequest = function nhapkhoDuyetRequest (formData, callback) {  
  return {
    type: Constants.NHAPKHO_DUYET_REQUESTING,
    formData, 
    callback
  }
}

export const nhapkhoDuyetSuccess = function nhapkhoDuyetSuccess (data) {  
  return {
    type: Constants.NHAPKHO_DUYET_SUCCESS,
    data
  }
}

export const nhapkhoDuyetError = function nhapkhoDuyetError (error) {  
  return {
    type: Constants.NHAPKHO_DUYET_ERROR,
    error
  }
}
export const nhapkhoHuyDuyetRequest = function nhapkhoHuyDuyetRequest (formData, callback) {  
  return {
    type: Constants.NHAPKHO_HUY_DUYET_REQUESTING,
    formData, 
    callback
  }
}

export const nhapkhoHuyDuyetSuccess = function nhapkhoHuyDuyetSuccess (data) {  
  return {
    type: Constants.NHAPKHO_HUY_DUYET_SUCCESS,
    data
  }
}

export const nhapkhoHuyDuyetError = function nhapkhoHuyDuyetError (error) {  
  return {
    type: Constants.NHAPKHO_HUY_DUYET_ERROR,
    error
  }
}
export const nhapkhoGenBarCodeRequest = function nhapkhoGenBarCodeRequest (formData,callback) {  
  return {
    type: Constants.NHAPKHO_GEN_BARCODE_REQUESTING,
    formData,
    callback,
  }
}

export const nhapkhoGenBarCodeSuccess = function nhapkhoGenBarCodeSuccess (data) {  
  return {
    type: Constants.NHAPKHO_GEN_BARCODE_SUCCESS,
    data
  }
}

export const nhapkhoGenBarCodeError = function nhapkhoGenBarCodeError (error) {  
  return {
    type: Constants.NHAPKHO_GEN_BARCODE_ERROR,
    error
  }
}

export const loadKhachHang = (formData, callback) => {
  return {
    type: Constants.LOAD_KHACH_HANG,
    payload: formData,
    onSuccess: callback
  }
}


// WEBPACK FOOTER //
// ./src/views/NhapKho/actions.js